import { Shield } from "lucide-react";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";
import { useMe } from "@/lib/api";
import { logger } from "@/lib/logger";
import { cn } from "@/lib/utils";

interface AdminNavLinkProps {
  /** Extra classes for the surrounding button, e.g. to tune spacing per header. */
  className?: string;
}

/**
 * The way into user management.
 *
 * `/admin/users` was only reachable by typing the URL. This renders the link
 * for admins and nothing for everyone else, off the same `useMe()` role that
 * `<AdminRoute>` gates on — so the link and the route can never disagree.
 */
export function AdminNavLink({ className }: AdminNavLinkProps) {
  const { data: me } = useMe();

  if (me?.role !== "admin") {
    return null;
  }

  logger.debug("[admin]", "showing admin entry point for", me.email);

  return (
    <Button asChild variant="ghost" size="sm" className={cn("shrink-0", className)}>
      <Link to="/admin/users" aria-label="User management">
        <Shield className="h-4 w-4" />
        <span className="hidden sm:inline">Admin</span>
      </Link>
    </Button>
  );
}
